// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3aSJe","additionalInfo":"AgreementModal_additionalInfo__3NcCS"};